import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TranslationService } from '../../../../services/translation.service';
import { MenuNode } from '../../../../classes';
@Component({
	selector: 'screen-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss']
})

export class ToastComponent implements OnInit, OnDestroy {

	@Input('debug') debug: boolean;
	enabled_buttons: Array<string>;
	currentNode: MenuNode = null;
	title: string;
	eventSubscription: any;
	mode: string;
	dashIcon: string = "";
	showIconBar = false;
	program: CallableFunction = null;
	unit: string = "";
	value: string = "";
	largeUnit: boolean = false;
	uppercase: boolean = true;
	constructor(private menuService: MenuService, private ioService: DataIoService, private translator: TranslationService) {

	}
	titleIcon(): string {
		return this.currentNode.getTitleIcon();
	}
	ngOnInit() {

		this.currentNode = this.menuService.getCurrentNode();
		if (this.currentNode.hasProgram()) {
			this.program = this.currentNode.getProgram();
			this.program(this);
		}
		if (this.currentNode.getValue() != "") {
			this.value = this.currentNode.getValue();
		}
		this.mode = "default";
		if (this.currentNode.hasParameter('setup')) {
			this.mode = 'setup';
		}
		if (this.currentNode.hasParameter('nouppercasesubtitle')) {
			this.uppercase = false;
		}
		this.title = this.currentNode.getTitle();

		this.dashIcon = this.currentNode.getIcon();
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event) => { this.eventHandler(event); }
		);
	}
	hasParameter(p: string): boolean {
		return this.currentNode.hasParameter(p);
	}
	ngOnDestroy() {
		this.eventSubscription.unsubscribe();
	}
	getColor(idx) {
		if (this.currentNode.hasParameter('darkText' + idx.toString())) {
			return 'grey';
		}
		return 'white';
	}
	eventHandler(event) {

		switch (event) {
			case 'confirm': {
				let confirmation = this.currentNode.onConfirm({});
				let targetNode = this.currentNode.getTargetNode();
				if (targetNode) {
					this.menuService.goto(targetNode, confirmation);
					return;
				}
				if (this.menuService.hasNextMenuItem()) {
					this.menuService.selectNextMenuItem();
				}
				break;
			}
			case 'back': {
				if (this.hasParameter('noback')) {
					return;
				}
				if (this.currentNode.hasBackTarget()) {
					let backTarget = this.currentNode.getBackTargetNode();
					this.menuService.goto(backTarget);
					return;
				}
				if (this.menuService.historyBack()) {
					return;
				}

				if (this.menuService.hasPreviousMenuItem()) {
					this.menuService.selectPreviousMenuItem();
				}
				break;
			}
		}
	}
	getText(idx: number): string {
		return this.currentNode.getText(idx);
	}
	getSubtitle() {
		return this.currentNode.getSubTitle();
	}
}
